import { render, staticRenderFns } from "./BuildReleases.vue?vue&type=template&id=e769ac2e&scoped=true&"
import script from "./BuildReleases.vue?vue&type=script&lang=js&"
export * from "./BuildReleases.vue?vue&type=script&lang=js&"
import style0 from "./BuildReleases.vue?vue&type=style&index=0&id=e769ac2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e769ac2e",
  null
  
)

export default component.exports